export default {"src":"/_next/static/image/public/images/flags/flag_353.79cdd76eb79868349358cc36cbc1ebd4.svg","height":16,"width":24};